import { useCallback, useMemo, useState } from 'react';
import { useMatches, useNavigate } from 'react-router-dom';
import type { QueryParamConfig} from 'use-query-params';
import { ChatPageContextDataContext, DispatchPageContextDataContext } from '@/components/Chat/context';
import { ChatWidget } from '@/components/Chat.Widget';
import { ChatContextType } from '@/enums/chat';
import type { BrandInsightsPageContext } from '@/types';

type Props = ChildrenProps;

export const ChatWidgetContainer = (props: Props) => {
  const matches = useMatches();
  const navigate = useNavigate();

  const [contextData, setContextData] = useState<BrandInsightsPageContext.Item>(null);

  const enabled = useMemo(() => {
    return matches.some(x => x.pathname.length && `/workspaces` === x.pathname.match(/^\/[^/]+/)?.[0]);
  }, [matches]);

  const handleClick = useCallback(() => {
    const qp: ContextItem = contextData
      ? contextData
      : { type: ChatContextType.Global } as ContextItem;

    navigate({
      pathname: `/chat`,
      search: `?ctx=${ContextItemParam.encode(qp)}`,
    });
  }, [
    contextData,
    navigate,
  ]);

  return (
    <DispatchPageContextDataContext.Provider value={setContextData}>
      <ChatPageContextDataContext.Provider value={contextData}>
        {enabled && <ChatWidget onClick={handleClick} />}
        {props.children}
      </ChatPageContextDataContext.Provider>
    </DispatchPageContextDataContext.Provider>
  );
};

type ContextItem = BrandInsightsPageContext.Item;

export const ContextItemParam: QueryParamConfig<ContextItem> = {
  encode: (state: ContextItem) => state ? Buffer.from(JSON.stringify(state)).toString('base64') : undefined,
  decode: (q: string) => q ? JSON.parse(Buffer.from(q, 'base64').toString()) as ContextItem : undefined,
};